<template>
  <div class="fertigation single-step">
    <FirstSection/>
    <TankDist v-if="tanks.length"/>
  </div>
</template>

<script>
import FirstSection from './FirstSection';
import TankDist from './TankDist';
import { mapGetters } from 'vuex'

export default {
  components: {
    FirstSection,
    TankDist,
  },
  computed: {
    ...mapGetters({
      tanks: 'program/fertigation/tanks',
    })
  },
  created() {
    this.$store.commit('program/fertigation/reset');
    this.$store.dispatch('program/fertigation/get');
  }
}
</script>

<style lang="scss" scoped>

.fertigation {

}

</style>
